import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { LoginAction, LoginType } from '../classes/static/enums';

export class LoginService {
	private static _loginActionSubj = new BehaviorSubject<LoginAction>(LoginAction.Login);
	public static readonly loginAction$ = LoginService._loginActionSubj.asObservable();

	private static _loginTypeSubj = new BehaviorSubject<LoginType>(null);
	public static readonly loginType$ = LoginService._loginTypeSubj.asObservable();

	public static setAction(action: LoginAction): void {
		this._loginActionSubj.next(action);
	}
	public static setType(type: LoginType): void {
		this._loginTypeSubj.next(type);
	}
}
